import { z } from "zod";

export const observationSchema = z.object({
	station_id: z.string(),
	data: z.object({
		present_weather: z.number().optional(),
		temperature: z.number().optional(),
		precipitation_1h: z.number().optional(),
		precipitation_3h: z.number().optional(),
		wind_direction: z.number().optional(),
		wind_speed: z.number().optional(),
		relative_humidity: z.number().optional(),
		visibility: z.number().optional(),
		feel_like: z.number().optional(),
		date: z.date().optional(),
	}),
});

export interface IStationWithObservation {
	station_id: string;
	label: string;
	priority?: number;
	position: [string, string];
	data: DataWeatherStation;
	Priority?: number;
}

export interface DataWeatherStation {
	present_weather: number;
	temperature: number;
	precipitation_1h: number;
	precipitation_3h: number;
	wind_direction: number;
	wind_speed: number;
	relative_humidity: number;
	visibility: number;
	feel_like: number;
}

export const observationsSchema = z.array(observationSchema);

export type observationsType = z.infer<typeof observationsSchema>;

export type IMergedObservationAndStation = {
	data: observationsType[number]["data"];
	priority?: number;
	coordinates?: string[];
	stationId?: string;
};
